export default {
  distributorSelected: null,
  userSelected: null,
};
